module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_3016.747bd6b9.png";